<!--
  功能：提交开票信息
  作者：Maoxiangdong
  邮箱：862755519@qq.com
  时间：2022年07月19日 14:31:08
-->
<template>
    <div>
        <div class="title-box">
            <div class="page-title">滇约出行为你开具</div>
            <div class="page-text">
                全部以电子发票开具 共<span>{{ orderDetails.length }}</span>行程 合计<span>{{ totalPrice }}</span>元
            </div>
        </div>
        <div class="card-title">开票信息</div>
        <van-form class="form-container" input-align="right">
            <van-field label="发票类型" class="form-item">
                <template #input>
                    <span>电子发票</span>
                </template>
            </van-field>
            <van-field label="抬头类型" required class="form-item">
                <template #input>
                    <div @click="titleTypeState = true">
                        <span>{{
                            formData.titleType == 0 ? '公司企业' : '个人/非企业'
                        }}</span>
                        <van-icon name="arrow" class="icon-right" />
                    </div>
                </template>
            </van-field>
            <van-field label="发票抬头" required class="form-item">
                <template #input>
                    <div @click="selectTitle">
                        <span>{{ formData.name || '请选择' }}</span>
                        <van-icon name="arrow" class="icon-right" />
                    </div>
                </template>
            </van-field>
            <van-field label="公司税号" class="form-item" required v-model="formData.taxNumber" readonly
                v-if="formData.titleType == 0" placeholder="请输入公司税号">
            </van-field>
            <van-field label="身份证号" class="form-item" required v-model="formData.taxNumber" readonly
                v-if="formData.titleType == 1" placeholder="请输入身份证号码">
            </van-field>
            <van-field label="发票内容" class="form-item" required v-model="formData.content" readonly placeholder="请输入发票内容">
            </van-field>
            <van-field label="发票金额" required class="form-item">
                <template #input>
                    <div>
                        <span style="color: #ff7307">{{ totalPrice }}</span> 元
                    </div>
                </template>
            </van-field>
            <van-field label="公司地址" class="form-item" rows="1" autosize type="textarea" v-model="formData.address"
                v-if="formData.titleType == 0" readonly placeholder="请输入公司地址">
            </van-field>
            <van-field label="备注信息" class="form-item" rows="1" type="textarea" autosize v-model="formData.remark"
                placeholder="请输入备注信息">
            </van-field>
            <div class="trip-box">提示：此备注内容会直接显示在发票备注栏里，请谨慎填写，如不需要请删除！</div>
        </van-form>
        <div class="card-title" v-if="formData.titleType == 0">
            账户信息（非必填）
        </div>
        <van-form class="form-container" v-if="formData.titleType == 0" input-align="right">
            <van-field label="开户行" v-model="formData.openBank" class="form-item" placeholder="请输入开户行">
            </van-field>
            <van-field label="开户账号" class="form-item" v-model="formData.openBankNumber" placeholder="请输入开户账号">
            </van-field>
        </van-form>
        <div class="card-title">接收信息</div>
        <van-form class="form-container" input-align="right">
            <van-field label="联系号码" v-if="formData.titleType == 1" v-model="formData.mobile" required class="form-item"
                placeholder="请输入联系号码">
            </van-field>
            <van-field label="公司号码" v-if="formData.titleType == 0" v-model="formData.mobile" class="form-item"
                placeholder="请输入公司号码">
            </van-field>
            <van-field label="电子邮箱" class="form-item" v-model="formData.email" required placeholder="请输入电子邮箱">
            </van-field>
        </van-form>
        <div class="button-container">
            <van-button type="primary" round class="button-box" @click="formVerify">提交信息</van-button>
        </div>
        <!-- 抬头类型选择 -->
        <van-action-sheet v-model="titleTypeState" :actions="titleTypeList" cancel-text="取消" title="选择发票抬头类型"
            :closeable="false" close-on-click-action @select="selectTitleType">
        </van-action-sheet>
    </div>
</template>

<script>
import {
    applyInvoice,
    groupApplyInvoice
} from 'api/invoice'
export default {
    // 组件名称
    name: 'Submitpage',
    // 组件参数 接收来自父组件的数据
    props: {},
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {
            orderType: 0, //订单类型 0网约车 1拼团车
            orderDetails: [], //开票订单
            titleTypeState: false,
            titleTypeList: [{
                name: '公司企业',
                value: 0
            },
            {
                name: '个人/非企业',
                value: 1
            }
            ],
            formData: {
                //提交表单类型
                titleType: 0, //抬头类型
                invoiceId: 0, //
                name: '', //名称
                taxNumber: '', //税号
                email: '', //邮箱
                sendTravelItinerary: 0,
                content: '客运服务费',
                issueType: 0, //开票类型 0第一次 1 重开
                address: '', //公司地址
                mobile: '', //联系号码
                openBank: '', //开户行
                openBankNumber: '', //开户信息
                remark: '', //备注
                orderDetails: []
            }
        }
    },
    // 计算属性
    computed: {
        //总金额
        totalPrice() {
            let total = 0
            this.orderDetails.forEach((element) => {
                total += element.priceIncludingTax
            })
            return total.toFixed(2)
        }
    },
    // 侦听器
    watch: {},
    // 组件方法
    methods: {
        selectTitle() {
            console.log('选择发票')
            this.$router.push({
                name: 'InvoiceTitleList',
                query: {
                    invoiceType: this.formData.titleType
                }
            })
        },
        // 表单验证
        formVerify() {
            if (!this.formData.name) {
                this.$toast('发票抬头不能为空')
                return;
            }
            //企业验证
            if (this.formData.titleType == 0) {
                if (!this.formData.taxNumber) {
                    this.$toast('企业税号不能为空')
                    return;
                } else {
                    let regular = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
                    if (!regular.test(this.formData.taxNumber)) {
                        this.$toast('企业税号格式不正确')
                        return;
                    }
                }
                // if (this.formData.openBankNumber) {
                //     let regular = /^(?:[1-9]{1})(?:\d{15}|\d{18})$/;
                //     if (!regular.test(this.formData.openBankNumber)) {
                //         this.$toast('开户账号格式不正确')
                //         return;
                //     }
                // }

            }
            if (!this.formData.email) {
                this.$toast('电子邮箱不能为空')
                return;
            }
            // else {
            //     let regular = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            //     if (!regular.test(this.formData.email)) {
            //         this.$toast('电子邮箱格式不正确')
            //         return;
            //     }
            // }
            this.handleSubmit();
        },
        //提交信息
        handleSubmit() {
            console.log(this.formData);
            let param = this.formData;
            //网约车开票提交
            if (this.orderType == 0) {
                console.log("网约车");
                applyInvoice(param).then((res) => {
                    this.$router.push({
                        name: 'InvoiceProgress'
                    })
                })
            }
            //拼团车开票提交
            if (this.orderType == 1) {
                console.log("拼团车");
                groupApplyInvoice(param).then((res) => {
                    // this.$toast('开票信息提交成功')
                    this.$router.push({
                        name: 'InvoiceProgress'
                    })
                })
            }

        },
        //选择抬头类型
        selectTitleType(event) {
            this.initFormData()
            this.formData.titleType = event.value
        },
        // 初始化参数
        initFormData() {
            this.formData = {
                //提交表单类型
                titleType: 0, //抬头类型
                invoiceId: 0, //
                name: '', //名称
                taxNumber: '', //税号
                email: '', //邮箱
                sendTravelItinerary: 0,
                content: '客运服务费',
                issueType: 0, //开票类型 0第一次 1 重开
                address: '', //公司地址
                mobile: '', //联系号码
                openBank: '', //开户行
                openBankNumber: '', //开户信息
                remark: '', //备注
                orderDetails: []
            }
        }
    },
    //在实例初始化之后，组件属性计算之前，如data属性等
    beforeCreate() { },
    //组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
    created() {
        this.orderDetails = JSON.parse(sessionStorage.getItem('orderDetails'))
        this.orderType = sessionStorage.getItem('orderType')
        this.formData.orderDetails = this.orderDetails;
        console.log(this.orderDetails);
        if (this.orderDetails) {
            let str = ''
            this.orderDetails.forEach(element => {
                let text = element.dataTime + element.name;
                str += text + "；"
            });
            str = str.substring(0, str.lastIndexOf('；'));
            this.formData.remark = str;
        }
        let titleData = JSON.parse(sessionStorage.getItem('titleData'))
        if (titleData) {
            this.formData.name = titleData.headerName;
            this.formData.address = titleData.address;
            this.formData.titleType = titleData.invoiceType;
            this.formData.taxNumber = titleData.taxNumber;
            this.formData.email = titleData.email;
            this.formData.mobile = titleData.mobile;
            this.formData.openBank = titleData.openBank;
            this.formData.openBankNumber = titleData.openBankNumber;
        }
    },
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() { },
    //挂载后
    mounted() { },
    //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() { },
    //数据更新时后调用
    updated() { },
    // keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
    activated() { },
    // keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() {
        sessionStorage.removeItem('titleData')
    }
}
</script>

<style lang="scss" scoped>
.trip-box {
    padding: 15px;
    color: #ff7307;
    font-size: 14px;
}

.button-container {
    padding: 30px 0px;
    text-align: center;
}

.button-box {
    margin: auto;
    width: 91%;
}

.icon-right {
    margin-left: 5px;
    font-size: 15px;
    color: #999;
    margin-top: -2px;
}

.form-container {
    width: 92%;
    border-radius: 8px;
    padding: 5px 0px;
    background-color: #fff;
    margin: auto;
    box-shadow: 0px 0px 3px 0px rgba(185, 184, 184, 0.1);
}

.form-item {
    font-size: 15px;
    padding: 13px 20px;
}

.page-title {
    color: #333;
    font-size: 22px;
    font-weight: 500;
}

.page-text {
    font-size: 15px;
    color: #555;
    margin-top: 5px;

    span {
        color: #ff7307;
        margin-left: 3px;
        margin-right: 3px;
    }
}

.title-box {
    background-color: #fff;
    padding: 15px;
    border-bottom: 1px solid #f3f3f3;
}

.card-title {
    font-size: 16px;
    color: #333;
    padding: 13px 15px;
}

.card-box {
    height: 200px;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px rgba(185, 184, 184, 0.1);
    border-radius: 8px;
    width: 93%;
    margin: auto;
}</style>
